import { render } from "./HowToDeleteAccount.vue?vue&type=template&id=4edca639"
import script from "./HowToDeleteAccount.vue?vue&type=script&lang=js"
export * from "./HowToDeleteAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__